import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './DropDown.scss';
import dropDownArrow from './Image/chevron.svg';

const DropDown = ({
  autoFocus,
  checkbox,
  checkboxArrayValue,
  CheckboxError,
  className,
  darkBorder,
  data,
  // defaultValue,
  disabled,
  error,
  greyBorder,
  htmlFor,
  label,
  labelClassName,
  labelContainerClassName,
  name,
  onChange,
  onChangeCheckboxArray,
  optionSelected,
  required,
  setOptionsToUpperCase,
  value,
  disableOnBlur
}) => {
  const classes = classNames('tmx-baseDropDown', className, { grey: greyBorder, dark: darkBorder });
  const callback = useCallback(
    (event) => {
      onChange(event);
    },
    [onChange]
  );

  const customDropDownRef = useRef(null);

  useEffect(() => {
    var checkList = document.getElementById('list1');
    if (checkList) {
      checkList.getElementsByClassName('anchor')[0].onclick = function () {
        if (checkList.classList.contains('tmx-baseDropDown__visible')) {
          checkList.classList.remove('tmx-baseDropDown__visible');
        } else {
          checkList.classList.add('tmx-baseDropDown__visible');
        }
      };
    }
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      var checkList = document.getElementById('list1');

      if (
        customDropDownRef.current &&
        !customDropDownRef.current.contains(event.target) &&
        checkList.classList.contains('tmx-baseDropDown__visible')
      ) {
        checkList.classList.remove('tmx-baseDropDown__visible');
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [customDropDownRef]);

  const valueChange = useCallback(
    (event) => {
      onChangeCheckboxArray(event);
    },
    [onChangeCheckboxArray]
  );

  return (
    <>
      {(label || error) && (
        <div className={classNames('tmx-baseDropDown__labelWrapper', labelContainerClassName)}>
          <div>
            {label && (
              <label
                className={classNames('tmx-baseDropDown__uploadFormLabel', labelClassName)}
                htmlFor={htmlFor}>
                {label} {required ? <sup>*</sup> : null}
              </label>
            )}
          </div>
          {error && <div className="tmx-baseDropDown__errorMessage">{error}</div>}
        </div>
      )}
      {!checkbox ? (
        <select
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus={autoFocus}
          style={{ backgroundImage: `url(${dropDownArrow})` }}
          className={classes}
          disabled={disabled}
          onBlur={!disableOnBlur ? callback : null}
          onChange={callback}
          // defaultValue={defaultValue}
          value={value}>
          {name ? (
            <option value="" disabled>
              {name}
            </option>
          ) : null}
          {data.map((data, key) => (
            <option defaultValue={optionSelected === key ? 'selected' : ''} key={key} value={data}>
              {setOptionsToUpperCase ? data.toUpperCase() : data}
            </option>
          ))}
        </select>
      ) : (
        <div id="list1" className="tmx-baseDropDown__dropdown-check-list" ref={customDropDownRef}>
          {checkboxArrayValue?.length > 0 ? (
            <span className="anchor">{checkboxArrayValue?.join(', ')}</span>
          ) : (
            <span className={CheckboxError ? 'anchor anchor--error' : 'anchor'}>
              Select Newsrooms
            </span>
          )}
          <ul className="items">
            <li>
              <input
                onChange={(event) => {
                  valueChange(event);
                }}
                type="checkbox"
                value="All Newsrooms we pitch"
                checked={checkboxArrayValue?.includes('All Newsrooms we pitch') ? true : false}
              />
              All Newsrooms we pitch
            </li>
            {data.map((data, key) => (
              <li key={key}>
                <input
                  onChange={(event) => {
                    valueChange(event);
                  }}
                  type="checkbox"
                  value={data}
                  checked={
                    checkboxArrayValue?.includes('All Newsrooms we pitch') ||
                    checkboxArrayValue?.includes(data)
                      ? true
                      : false
                  }
                />
                {data}
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

DropDown.propTypes = {
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  darkBorder: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.string),
  // defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  greyBorder: PropTypes.bool,
  htmlFor: PropTypes.string,
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  labelContainerClassName: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  optionSelected: PropTypes.number,
  required: PropTypes.bool,
  setOptionsToUpperCase: PropTypes.bool,
  value: PropTypes.string,
  checkbox: PropTypes.bool,
  onChangeCheckboxArray: PropTypes.func,
  checkboxArrayValue: PropTypes.array,
  CheckboxError: PropTypes.bool,
  disableOnBlur: PropTypes.bool
};

DropDown.defaultProps = {
  darkBorder: false,
  defaultValue: '',
  disabled: false,
  greyBorder: false,
  name: '',
  optionSelected: null,
  setOptionsToUpperCase: false,
  value: '',
  checkbox: false,
  CheckboxError: false,
  disableOnBlur: false
};

export default DropDown;
